import React from 'react';
import {useControllerProps} from '../../../../../domain/controllers/ControllerContext';
import {classes} from './Body.st.css';
import {CartItems} from '../../../../../common/components/CartItems/CartItems';
import {Text} from 'wix-ui-tpa';
import settingsParams from '../../../settingsParams';
import stylesParams from '../../../stylesParams';
import {useSettings, useStyles} from '@wix/tpa-settings/react';

export enum BodyDataHooks {
  emptyState = 'BodyDataHooks.emptyState',
}

export const Body = () => {
  const {shouldRenderEmptyState} = useControllerProps().cartStore;
  const {get: getSettings} = useSettings();
  const {get: getStyles} = useStyles();
  const showQuantityBySettings = getStyles(stylesParams.CART_ITEM_QUANTITY_COUNTER_VISIBILITY);
  const showThumbnailBySettings = getStyles(stylesParams.CART_ITEM_IMAGE_VISIBILITY);
  const shouldShowItemInfoBySettings = getStyles(stylesParams.CART_ITEM_INFO);

  return (
    <div>
      {shouldRenderEmptyState ? (
        <div className={classes.emptyState}>
          <Text data-hook={BodyDataHooks.emptyState} className={classes.emptyStateText}>
            {getSettings(settingsParams.CART_EMPTY_CART) as string}
          </Text>
        </div>
      ) : (
        <CartItems
          hideLastDivider={true}
          showQuantityBySettings={showQuantityBySettings}
          showThumbnailBySettings={showThumbnailBySettings}
          shouldShowItemInfoBySettings={shouldShowItemInfoBySettings}
        />
      )}
    </div>
  );
};
